import React from 'react';

import './loader.scss';

const Loader: React.FC = (): JSX.Element => {
  return (
    <div className="loading-container">
      <span className="loading"></span>
    </div>
  );
};

export default Loader;
